/* Modanaire — global header behaviour */
(function () {
  'use strict';

  function init() {
    var header = document.getElementById('mHeader');
    var announcement = document.getElementById('mAnnouncement');
    var hamburger = document.getElementById('mHamburger');
    var menu = document.getElementById('mMobileMenu');

    /* --- Scroll state: hide the announcement bar, glass the header --- */
    if (header) {
      var ticking = false;

      var applyScrollState = function () {
        var y = window.pageYOffset || document.documentElement.scrollTop;
        var past = y > 40;
        header.classList.toggle('scrolled', past);
        if (announcement) announcement.classList.toggle('hidden', past);
        ticking = false;
      };

      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(applyScrollState);
          ticking = true;
        }
      }, { passive: true });

      // Run once so a reload part-way down the page renders correctly
      applyScrollState();
    }

    /* --- Mobile menu --- */
    if (hamburger && menu) {
      var setMenu = function (open) {
        hamburger.classList.toggle('active', open);
        menu.classList.toggle('open', open);
        hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.style.overflow = open ? 'hidden' : '';
      };

      hamburger.addEventListener('click', function () {
        setMenu(!menu.classList.contains('open'));
      });

      // Close after tapping a link, and on Escape
      Array.prototype.forEach.call(menu.querySelectorAll('a'), function (link) {
        link.addEventListener('click', function () { setMenu(false); });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.classList.contains('open')) setMenu(false);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when the section is re-rendered inside the theme editor
  document.addEventListener('shopify:section:load', init);
})();
